import React from 'react';
import { Tag, Typography } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';

/**
 * ArchiveDocumentStatus — status cell for an archive document (REQ-005, FE-5-15)
 * Location: frontend/src/components/archive/ArchiveDocumentStatus.js
 *
 * Shows the processing status tag and, for a failed document, the reason the
 * backend gives in `processing_error` (CONTRACTS.md → "Archive document failure
 * reason"): a user-readable sentence such as "This file type can't be indexed
 * for search yet. Upload a PDF, PowerPoint or Word (.docx) file." Rendered as plain text.
 */

const STATUSES = {
  ready: { icon: <CheckCircleOutlined />, color: 'success', text: 'Ready' },
  failed: { icon: <CloseCircleOutlined />, color: 'error', text: 'Failed' },
  pending: { icon: <ClockCircleOutlined />, color: 'processing', text: 'Processing' },
};

const ArchiveDocumentStatus = ({ processingStatus, processingError }) => {
  const status = STATUSES[processingStatus] || STATUSES.pending;
  const reason = processingStatus === 'failed' && typeof processingError === 'string'
    ? processingError.trim()
    : '';

  return (
    <div>
      <Tag icon={status.icon} color={status.color}>
        {status.text}
      </Tag>
      {reason && (
        <Typography.Text
          type="secondary"
          style={{ display: 'block', marginTop: 4, fontSize: 12, lineHeight: 1.4, overflowWrap: 'anywhere' }}
        >
          {reason}
        </Typography.Text>
      )}
    </div>
  );
};

export default ArchiveDocumentStatus;
